import { html } from "lit-html";
import {
	BY_DISCOUNT,
	BY_POPULARITY,
	BY_PRICE_AND_POPULARITY,
	BY_SCORE_AND_POPULARITY,
} from "./Sorters";
import { translate } from "@escapio/shared/l10n/translate";
import { Selector } from "./Selector";

import "./Info";

customElements.define(
	"esc-hotel-list-sorting-selector-desktop",
	class extends Selector {
		constructor() {
			super([
				{
					value: BY_POPULARITY,
					label: html`
						${translate("hotel_list_sort_by_popularity")}
						<esc-hotel-list-sorting-info
							origin="Liste"
							info-text=${translate("hotel_list_sorting_info")}
							details-url=${translate("hotel_list_sorting_info_details_url")}
							details-label=${translate(
								"hotel_list_sorting_info_details_label",
							)}
							class="sorting-info-dropdown--list-filter-box"
						></esc-hotel-list-sorting-info>
					`,
				},
				{
					value: BY_PRICE_AND_POPULARITY,
					label: translate("hotel_list_sort_by_price"),
				},
				{
					value: BY_DISCOUNT,
					label: translate("hotel_list_sort_by_discount"),
				},
				{
					value: BY_SCORE_AND_POPULARITY,
					label: translate("hotel_list_sort_by_rating"),
				},
			]);
		}
	},
);
